import type {
  Column as ReactTableColumn,
  RowData,
  Table as ReactTable,
} from '@tanstack/react-table';

import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';
import {cn} from '@/utils/ui';

import type {TableSelectFilterMeta} from '../tableFilterTypes';

export type SelectFilterMenuItemProps<TData extends RowData> = {
  column: ReactTableColumn<TData, unknown>;
  filter: TableSelectFilterMeta<TData>;
  label: string;
  table: ReactTable<TData>;
};

export function SelectFilterMenuItem<TData extends RowData>({
  column,
  filter,
  label,
  table,
}: SelectFilterMenuItemProps<TData>) {
  const options =
    typeof filter.options === 'function'
      ? filter.options(table)
      : filter.options;
  const isActive = column.getFilterValue() !== undefined;

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger
        className={cn(isActive && 'font-medium text-secondary-500')}
      >
        {label}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {options.map(option => (
          <DropdownMenuItem
            className={cn(
              column.getFilterValue() === option.value &&
                'font-medium text-secondary-500'
            )}
            key={option.value}
            onClick={() => column.setFilterValue(option.value)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
